import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Popup from 'reactjs-popup';
import { toast } from 'react-toastify';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import AppActions from '~/actions/app';
import CompanyActions from '~/actions/company';
import { UserRoles } from '~/services/config';

function Profile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const popup = useRef();
    const user = useSelector((state) => state.app.user);
    const community = useSelector((state) => state.app.user?.community_user);
    const companies = useSelector((state) => state.app.companies);
    const userName = useSelector((state) => state.app.user_name);
    const userRole = useSelector((state) => state.app.primary_role_id);
    const avatar = useSelector((state) => state.app.avatar);
    const superAdminRole = UserRoles.SUPER_ADMIN;

    const handleUserProfile = (e) => () => {
        const route = `/${community.entity?.slug}/${e}`;
        window.location.replace(route);
    };

    const handleSuperAdmin = () => {
        dispatch(AppActions.onprofilepageRequest('superadmin'));
        const route = `/vendor-ratings/company-mgt`;
        navigate(route);
        popup.current.close();
    };

    const handleCompanyProfile = () => {
        let id;
        if (user.companies.length && user.companies[0].id != 38) {
            id = find(propEq('id', user.company_info.id), companies).business_id;
        } else if (user.businesses.length) {
            id = user.businesses[0].id;
        }
        if (id) {
            const company = find(propEq('business_id', id), user?.community_user?.companies);
            const route = company?.entity?.slug ? { pathname: `/${company.entity.slug}/about` } : { pathname: '/business/about', search: `?id=${id}` };
            dispatch(CompanyActions.getbusinessRequest({ id }, route));
        } else {
            toast.error('You do not have a connected company. Please contact our support to connect a company', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        }
        popup.current.close();
    };

    const handleLogout = () => {
        // Clear Redux state
        dispatch(AppActions.logoutRequest());
        // Immediate redirect to prevent any flash of error/loading states
        navigate('/hcm');
    };

    return (
        <Popup
            arrow={false}
            position="bottom right"
            ref={popup}
            className="popup-content"
            trigger={(open) => (
                <div className="d-v-center cursor ms-4">
                    <Avatar type="logo" name={userName} url={avatar} isSponsored={true} />
                    <div className="d-flex mt-1 user-name">
                        <span className="dsl-w12 me-1">{community?.first_name.substr(0, 10)}</span>
                        <Icon name={`fas fa-angle-${open ? 'up' : 'down'}`} size={10} color="white" />
                    </div>
                </div>
            )}
        >
            <div className="px-3 py-1 profile-item" onClick={handleUserProfile('about')}>
                <span className="cursor dsl-b14">My Profile</span>
            </div>
            <div className="px-3 py-1 profile-item" onClick={handleCompanyProfile}>
                <span className="cursor dsl-b14">My Company</span>
            </div>
            {superAdminRole >= userRole && (
                <div className="px-3 py-1 profile-item" onClick={handleSuperAdmin}>
                    <span className="cursor dsl-b14">Super Admin</span>
                </div>
            )}
            <div className="px-3 py-2 profile-item" onClick={handleLogout}>
                <span className="cursor dsl-b14">Sign out</span>
            </div>
        </Popup>
    );
}

export default Profile;
